module.exports = __webpack_public_path__ + "img/wireframes_04.58303bd1.png";